import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import SpaIcon from '@mui/icons-material/Spa';
import PublicIcon from '@mui/icons-material/Public';

const ValuesSection = styled(Box)(({ theme }) => ({
  padding: '80px 0',
}));

const ValueItem = styled(Paper)(({ theme }) => ({
  padding: '20px',
  borderRadius: '8px',
  textAlign: 'center',
  boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
  height: '100%',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px) scale(1.04)',
  },
}));

const IconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: theme.spacing(1.5),
  fontSize: 48,
  color: theme.palette.primary.main,
  transition: 'transform 0.4s cubic-bezier(.4,2,.6,1)',
  '.MuiPaper-root:hover &': {
    transform: 'scale(1.15) rotate(-8deg)',
    color: '#c9a74c', // use gold directly
  },
}));

const ValueTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '22px',
  fontWeight: 'bold',
  marginBottom: '10px',
}));

const valuesData = [
  {
    icon: <VerifiedUserIcon fontSize="inherit" />, // Integrity
    title: 'values.integrity.title',
    description: 'values.integrity.description',
  },
  {
    icon: <AccessTimeIcon fontSize="inherit" />, // Reliability
    title: 'values.reliability.title',
    description: 'values.reliability.description',
  },
];

const Values = () => {
  const { t } = useTranslation();

  return (
    <ValuesSection id="values">
      <Container>
        <Typography variant="h2" component="h2" align="center" gutterBottom>
          {t('values.title')}
        </Typography>
        <Grid container spacing={3} justifyContent="center">
          {valuesData.map((value, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <ValueItem>
                <IconWrapper>{value.icon}</IconWrapper>
                <ValueTitle>{t(value.title)}</ValueTitle>
                <Typography>{t(value.description)}</Typography>
              </ValueItem>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ValuesSection>
  );
};

export default Values; 